import { Box, Container, Heading, Text, VStack, Button, List, ListItem, ListIcon } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

function Teach() {
  return (
    <Box>
      <Container maxW="800px" py={12}>
        <VStack spacing={8} align="stretch">
          <Heading as="h1" size="2xl" textAlign="center" color="teal.800">
            Teach For Mock Me, Please!
          </Heading>
          
          <Text fontSize="lg" textAlign="center">
            Share your expertise and help the next generation of musicians prepare for their auditions.
          </Text>

          <Box bg="white" p={8} borderRadius="lg" boxShadow="sm">
            <VStack spacing={6} align="stretch">
              <Heading size="md" color="teal.800">Why Teach With Us?</Heading>
              
              <List spacing={3}>
                <ListItem>
                  <ListIcon as={CheckIcon} color="teal.500" />
                  Flexible schedule - teach when you want
                </ListItem>
                <ListItem>
                  <ListIcon as={CheckIcon} color="teal.500" />
                  Work from anywhere - all sessions are virtual
                </ListItem>
                <ListItem>
                  <ListIcon as={CheckIcon} color="teal.500" />
                  Competitive compensation
                </ListItem>
                <ListItem>
                  <ListIcon as={CheckIcon} color="teal.500" />
                  Help shape the future of classical music
                </ListItem>
              </List>

              <Text mt={4}>
                We're looking for experienced orchestral musicians who have successfully navigated the audition process and want to help others do the same.
              </Text>

              <Button colorScheme="teal" size="lg" mt={4}>
                Apply Now
              </Button>
            </VStack>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
}

export default Teach; 